<template>
  <!-- placeholder div so this component can mount -->
  <div></div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";

const THRESHOLD = 300; // change this to whatever scroll depth you like
const hasLoaded = ref(false);

function injectScript() {
  if (hasLoaded.value) return;
  hasLoaded.value = true;

  const script = document.createElement("script");
  script.src = "https://embed.tawk.to/68114879a34a48190eed1140/1iq1o66lk";
  script.async = true;
  script.charset = "UTF-8";
  script.setAttribute("crossorigin", "*");
  script.onload = () => window.dispatchEvent(new Event("tawkScriptLoaded"));
  document.body.appendChild(script);
}

function onScroll() {
  if (window.scrollY > THRESHOLD) {
    injectScript();
    window.removeEventListener("scroll", onScroll);
  }
}

onMounted(() => {
  // if the user has already scrolled past the threshold (e.g. via an in-page link),
  // load immediately; otherwise wait for scroll.
  if (window.scrollY > THRESHOLD) {
    injectScript();
  } else {
    window.addEventListener("scroll", onScroll);
  }
});

onUnmounted(() => {
  window.removeEventListener("scroll", onScroll);
});
</script>
